import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "dashboard",
    component: () => import("../presentation/pages/Index.vue"),
    meta: {
      layout: "default",
      requiresAuth: true,
      action: "view",
      subject: "dashboard",
    },
  },
];
